import React from 'react';

type Props = {
    children: React.ReactNode;
    device: 'mobile' | 'desktop';
};

const HideOn = ({ device, children }: Props) => {
    return (
        <div className={device === 'mobile' ? 'hidden md:block' : 'block md:hidden'}>
            {children}
        </div>
    );
};

export default HideOn;
